import { buildApiUrl, API_ENDPOINTS } from '../config/api';

export const fetchReceiptSettings = async (token) => {
  const response = await fetch(buildApiUrl(API_ENDPOINTS.RECEIPT_SETTINGS), {
    headers: {
      'Authorization': `Bearer ${token || localStorage.getItem('token')}`,
      'Content-Type': 'application/json'
    }
  });
  const result = await response.json();
  if (!response.ok) {
    throw new Error(result.error || 'Failed to load unit receipt settings');
  }
  return result.receiptSettings;
};

export const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, character => ({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
})[character]);
